import { useState } from "react";

const faqs = [
  {
    q: "瓜圈速报上的快讯多久更新一次？",
    a: "页面按发布时间倒序同步，正常情况下每天多次更新。遇到突发爆料，会先发一条简短快讯，再随着各方回应补充完整的时间线。",
  },
  {
    q: "「突发」标签代表消息已经确认了吗？",
    a: "不完全是。突发只代表话题在短时间内快速发酵、讨论量大，具体事实仍要以当事人和官方回应为准。我们会在正文里区分「已确认」和「仍在讨论」的部分。",
  },
  {
    q: "为什么速报里很少出现全名？",
    a: "对于尚未被当事人或官方明确确认的信息，我们倾向于用可识别的描述代替全名，避免把猜测当成结论，也减少对无关的人造成困扰。",
  },
  {
    q: "后续回应和反转会同步吗？",
    a: "会。同一条速报会持续跟进，只要出现新的声明、澄清或进展，都会更新到详情页的时间线里，不需要你再去翻旧的讨论。",
  },
  {
    q: "我发现了新线索，怎么投稿？",
    a: "可以发邮件到 hi@guaspeed.example.com，尽量附上公开可查的来源和时间点。我们会自行核实后再决定是否整理成速报。",
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <span className="inline-flex items-center gap-2 text-xs font-medium text-primary-600 tracking-[0.2em]">
            <span className="w-6 h-px bg-primary-500" />
            FAQ
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-tight">
            关于速报，
            <br />
            你可能想问
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            第一次来瓜圈速报，常见的问题都放在这里了。还有别的疑问，欢迎邮件告诉我们。
          </p>
          <a
            href="mailto:hi@guaspeed.example.com"
            rel="nofollow"
            className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-mail-send-line" />
            </span>
            联系编辑部
          </a>
        </div>

        <div className="lg:col-span-8">
          <div className="bg-background-50 border border-background-200 rounded-lg overflow-hidden divide-y divide-background-200">
            {faqs.map((faq, idx) => {
              const isOpen = openIndex === idx;
              return (
                <div key={faq.q}>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : idx)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 text-left px-5 md:px-6 py-5 cursor-pointer hover:bg-background-100 transition-colors"
                  >
                    <span className="flex items-center gap-3">
                      <span className="shrink-0 w-6 h-6 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 font-heading text-xs font-black">
                        Q
                      </span>
                      <span className="font-medium text-sm md:text-base text-foreground-950">{faq.q}</span>
                    </span>
                    <span className="shrink-0 w-6 h-6 flex items-center justify-center text-foreground-500">
                      <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-lg`} />
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 md:px-6 pb-5 -mt-1">
                      <p className="pl-9 text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default FaqSection;